/**
 * Created by fengc on 2020/04/02.
 */
import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import Letter from "./Letter";
import { GetWordStyleBySentenceCommand, EnumHasFlag } from "../../utils/MarkTextHelper";
import Constants from "../../config/Constants";
import "../../assets/typo/typo.css";

class Word extends React.Component {
	render() {
		let letterStyle = { ...this.props.letterStyle, ...styles.letterFontFamily };

		for (var key in this.props.style) {
			if (!(key === "color" || key.indexOf("font") !== -1)) continue;

			// if this "font" property is undefined in letterStyle, it will be added to letterStyle!
			if (!letterStyle[key]) {
				letterStyle[key] = this.props.style[key];
			}
		}
		let containerStyle = styles.container;
		if (this.props.style) {
			containerStyle = { ...containerStyle, ...this.props.style };
		}

		let { chars, syllables, command, sentenceIndex, wordIndex } = this.props.data;
		if (!_.isArray(chars)) {
			chars = _.toArray(chars);
		}


		//we already has command return
		const style = GetWordStyleBySentenceCommand(command);

		if (EnumHasFlag(command, Constants.TEXT_MARK_TYPE.TYPO)) {

			return (
				<div style={{ ...style, ...containerStyle }} onClick={this._handleClicked.bind(this)}>
					{chars && (this.props.language === 'zh') && chars.map((item, i) => {
						const charCode = item.charCodeAt(0);
						return (
							<i
								className={`typo icon${charCode}`}
								style={{ ...letterStyle, ...styles.typo }}
							/>
						);
					})}

				</div>
			);
		}


		return (
			<div style={{ ...style, ...containerStyle }} onClick={this._handleClicked.bind(this)}>
                            {(this.props.language !== 'zh') ?
                             (<div style={{ fontSize: 16, fontWeight: 'normal', lineHeight: 1.5, whiteSpace: 'pre-wrap', wordBreak: "break-all", ...style, ...letterStyle }}>{chars ? chars.join("") : ""}</div>) : null}
				{chars && (this.props.language === 'zh') &&
					syllables &&
					chars.map((item, i) => {
						if (this.props.overriddenLetters && this.props.overriddenLetters.letters && this.props.overriddenLetters.renderOverriddenLetter) {
							for (let j = 0; j < this.props.overriddenLetters.letters.length; j++) {
								// the struct of letter should be {char:"",pinyin:""}
								var letter = this.props.overriddenLetters.letters[j];
								if ((letter.char === item && letter.pinyin === syllables[i] && !_.has(letter, "index")) || (_.has(letter, "index") && letter.index === i)) {
									// TODO: consider the index of special letter ?
									// The event here cannot be registered automatically.
									// Please register the corresponding event manually in the render method
									return this.props.overriddenLetters.renderOverriddenLetter(letter, i);
								}
							}
						}
						return (
							<Letter
								key={i}
								style={letterStyle}
								data={{
									char: item,
									pinyin: syllables[i],
									sentenceIndex,
                                    wordIndex,
                                    letterIndex: i,
								}}
								charVisible={this.props.charVisible}
								pinyinVisible={this.props.pinyinVisible}
								onSyllableChange={this.props.onSyllableChange}
								onClick={this._handleLetterClicked.bind(this, {
								    char: item,
									pinyin: syllables[i],
								})}
							/>
						);
					})}
			</div>
		);
	}

	_handleClicked() {
		if (this.props.onClick) {
			this.props.onClick(this.props.data);
		}
	}
	_handleLetterClicked(data) {
		if (this.props.onLetterClick) {
			this.props.onLetterClick(data);
		}
		if (this.props.onClick) {
			this.props.onClick(this.props.data);
		}
	}
}

const styles = {
	container: {
		display: "flex",
		flexDirection: "row",
		margin: "5px 0px",
	},
	typo: {
		fontSize: 20,
	},
	letterFontFamily: {
		//fontFamily: "SourceHansansCN",
		fontWeight: 400,
	}
};

Word.propTypes = {
	data: PropTypes.object,
	style: PropTypes.object,
	letterStyle: PropTypes.object,
	onClick: PropTypes.func,
	onLetterClick: PropTypes.func,
	onSyllableChange: PropTypes.func,
	charVisible: PropTypes.bool,
	pinyinVisible: PropTypes.bool,
	overriddenLetters: PropTypes.object,
	renderOverriddenLetter: PropTypes.func,
};

Word.defaultProps = {
	data: {
		syllables: [],
		chars: [],
	},
    language: 'zh',
	style: {},
	letterStyle: {},
	onClick: null,
	onLetterClick: null,
	onSyllableChange: null,
	charVisible: true, // if show Chinese character
	pinyinVisible: true, // if show piyin of chinese character
	overriddenLetters: { letters: [], renderOverriddenLetter: null }, // customize letters' display and control
};

export default Word;
